/* eslint-disable */
<template>
  <div class="d-flex login-backround">

    <div class="d-flex flex-column h-100 w-100">
      <div class="font-size-lg px-5 py-3 text-center text-md-right text-white" style="visibility: collapse;">
        Copyright &copy; Getac Technology Corporation. All Rights Reserved
      </div>
      <div class="my-auto d-flex">
        <div class="align-items-center d-flex flex-wrap mx-auto">
          <div class="fixed-top h3 mb-0 mx-auto px-3 px-md-5 py-4 text-white d-lg-none">
            <div class="d-flex flex-nowrap align-items-end mb-2">
              <img class="getac-log" :src="imgUrl" alt="getac img" />
              <div class="border-right border-white mx-3" style="height: 25px;"></div>
              <div class="font-weight-bold h2 mb-0">FTIE System</div>
            </div>
          </div>
          <div class="h3 mb-0 mx-auto px-3 px-md-5 py-4 text-white">
            <div class="flex-nowrap align-items-end mb-2 d-none d-lg-flex">
              <img class="getac-log" :src="imgUrl" alt="getac img"/>
              <div class="border-right border-white mx-3" style="height: 25px;"></div>
              <div class="font-weight-bold h2 mb-0">FTIE System</div>
            </div>
            <div class="text-center text-md-left pt-2">Welcome to Field Technical Issue Escalation System!</div>
          </div>
          <div class="mx-auto px-0 px-md-5">
            <div class="card" style="width: 25rem;">
              <div class="card-body p-5">
                <div class="font-weight-bold h4 text-primary">Please login</div>
                <div class="form-group mt-4">
                  <label>Email</label>
                  <input type="text" class="form-control" v-model="user_email" />
                </div>
                <button type="button" class="btn btn-primary btn-block mt-5" @click="loginAzureUser">Next Step</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="font-size-lg px-5 py-3 text-center text-md-right text-white">
        Copyright &copy; Getac Technology Corporation. All Rights Reserved
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AzureLogin',
    data() {
      return {
        user_email: '',
        imgUrl: '../../static/image/logo_Getac.svg',
        authUrl: '',
        clientId: '',
        frontendUrl: '',
      }
    },
    mounted: function () {
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.clientId = this.$options.filters['clientId']();
      this.checkLoggedIn();
    },
    methods: {
      loginAzureUser() {
        let self = this;
        let backUrl = self.$route.query.backUrl;
        if (backUrl) {
          window.location.href = `${self.authUrl}Auth/SignIn?client_id=${self.clientId}&redirect_uri=${encodeURIComponent(`${self.frontendUrl}callback?backUrl=${backUrl}`)}&login_hint=${encodeURIComponent(self.user_email)}`;
        } else {
          window.location.href = `${self.authUrl}Auth/SignIn?client_id=${self.clientId}&redirect_uri=${encodeURIComponent(`${self.frontendUrl}callback`)}&login_hint=${encodeURIComponent(self.user_email)}`;
        }
      },
      redirectDevLogin() {
        let self = this;
        self.$router.push('login');
      },
      logoutUser() {
        let self = this;
        window.location.href = `${self.authUrl}Auth/SignOut?redirect_uri=${encodeURIComponent(self.frontendUrl + 'azure-login')}`;
      },
      checkLoggedIn(){
        let self = this;
        if (self.$session.has('user_name') && self.$store.state.token) {
          if(self.$route.query.backUrl){
            // slice last / in  frontendUrl
            window.location.href = `${self.frontendUrl.slice(0, -1)}${self.$route.query.backUrl}`;
          }else{
            self.$router.push({ path: '/home' });
          }
        }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AzureLogin.vue